import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import PricingPage from './pages/PricingPage';
import CreditsPage from './pages/CreditsPage';
import HistoryPage from './pages/HistoryPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import SettingsPage from './pages/SettingsPage';
import MissionPage from './pages/MissionPage';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="min-h-screen bg-slate-950">
          <Navigation />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/mission" element={<MissionPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/credits" element={<CreditsPage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
          </Routes>
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
